module.exports = __webpack_public_path__ + "static/media/aboutheader5.a9ef2f93.jpg";